import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Headers } from '@angular/http';

import { EnvironmentService } from '../../services/environment.service';
//import { CookieService } from 'ngx-cookie';

@Injectable()
export class AuthorizationService {
    private AUTHBASE_URL: string;
    private APPBASE_URL: string;
    //private AUTHBASE_URL: string = environment.AUTHBASE_URL; //'http://localhost:47119/auth';
    //private APPBASE_URL: string = environment.APPBASE_URL; //'http://localhost:5001';
    private loggedIn: boolean = false;
    public token: string = null;

    constructor(private http: Http, private environment: EnvironmentService) {
        this.AUTHBASE_URL = environment.AUTHBASE_URL;
        this.APPBASE_URL = environment.APPBASE_URL;
    }

    public fetchToken() {
        // all attempts to stop cache: setting headers, changing to post and sending current datetime, adding querystring with current date time
        // none are stopping cache of use claims, at least not on IIS Express
        this.token = null;

        let rightNow = new Date();
        let thisAuthorizationService = this;
        var promise = this.http.get(`${this.AUTHBASE_URL}/GetToken?now=${rightNow}`)
            .map(response => response.json()).toPromise();

        promise.then(data => {
            localStorage.setItem('userToken', data.token);
        });
        promise.catch(error => {
            localStorage.setItem('userToken', '');
        });
        return promise;
    }

    public getToken(): string {
        if (this.token == null) {
            this.token = localStorage.getItem('userToken');
        }

        return this.token;
    }

    public postAuthHeader(): Headers {
        let header = new Headers({
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' + this.getToken()
        });

        return header;
    }

    public getAuthHeader(): Headers {
        let header = new Headers({'Authorization': 'Bearer ' + this.getToken()});

        return header;
    }

    isLoggedIn(): boolean {
        var token = localStorage.getItem('userToken');

        if (token.length > 0) {
            return true;
        }

        return false;
    }

    //ngOnInit() {
    //    let cookieValue = this._cookieService.get('tablemonkey_user');

    //    // TODO Should check for expiration
    //    if (cookieValue !== undefined && cookieValue !== null) {
    //        this.loggedIn = true;
    //    }
    //}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/services/authorization.service.ts